import { useContext } from "react";

import { TabsContext } from "./Tabs.Provider";

export const useTabsState = () => {
  return useContext(TabsContext);
};
